import React, { useContext } from "react";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Container } from "@material-ui/core";

import { createStyles, makeStyles } from "@material-ui/core/styles";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@material-ui/icons/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@material-ui/icons/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import { Rating } from "@material-ui/lab";
import { FormContext } from "../../util/context";
const useStyles = makeStyles((theme) =>
  createStyles({
    smallRadioButton: {
      "& svg": {
        width: "2.5em",
        height: "2.5em",
      },
    },
  })
);

function IconContainer(props) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

const customIcons = {
  5: {
    icon: <SentimentVeryDissatisfiedIcon />,
    label: "I was extremely irritable",
  },
  4: {
    icon: <SentimentDissatisfiedIcon />,
    label: "I was irritable",
  },
  3: {
    icon: <SentimentSatisfiedIcon />,
    label: "I was somewhat irritable",
  },
  2: {
    icon: <SentimentSatisfiedAltIcon />,
    label: "I was a little bit irritable",
  },
  1: {
    icon: <SentimentVerySatisfiedIcon />,
    label: "I was not irritable",
  },
};

const Irritability = () => {
  const [form, setForm] = useContext(FormContext);
  const classes = useStyles();
  const [value, setValue] = React.useState(2);
  const [hover, setHover] = React.useState(-1);
  return (
    <>
      <Container maxWidth="sm">
        <Typography align="center" variant="h4">
          How were your irritability levels over the past month?
        </Typography>
      </Container>
      <Box mt={5}>
        <Container maxWidth="sm">
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
              <Rating
                name="customized-icons"
                className={classes.smallRadioButton}
                value={form.irritability}
                getLabelText={(value) => customIcons[value].label}
                IconContainerComponent={IconContainer}
                onChange={(event, newValue) => {
                  setValue(newValue);
                  setForm({
                    ...form,
                    irritability: newValue,
                    count: form.count + 1,
                  });
                }}
                onChangeActive={(event, newHover) => {
                  setHover(newHover);
                }}
              />
              {value !== null && (
                <Box ml={2}>
                  <Typography variant="h6">
                    {customIcons[hover !== -1 ? hover : value].label}
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default Irritability;
